<template>
<!--  <Panel :header="$t('ownSalesActivity') + (periodLabel ? ' (' + periodLabel + ')' : '')" :toggleable="true" :collapsed="isCollapsed">-->
  <Panel :toggleable="true" :collapsed="isCollapsed">
    <template #header>
      <div class="statistics-panel-header">
        <b>{{ $t('ownSalesActivity') }}</b>
        <span v-if="periodLabel" class="p-text-secondary statistics-panel-date p-mr-2">
          {{ periodLabel }}
        </span>
      </div>
    </template>
    <div class="datatable-wrapper" v-if="!objectIsEmpty">
      <table class="p-datatable p-datatable-striped p-datatable-sm p-datatable-hoverable-rows positions-table">
        <thead class="p-datatable-tbody">
        <tr class="table-opened-info__header-row">
          <th style="width: 18%"></th>
          <th style="width: 10%">{{ $t('Qty') }}</th>
          <!--              <th style="width: 12%">{{ $t('purchasePriceShortLabel') }}</th>-->
          <th style="width: 12%">{{ $t('sellingPriceShortLabel') }}</th>
          <!--              <th style="width: 12%">{{ $t('Tax') }}</th>-->
          <th style="width: 12%">{{ $t('Discount') }}</th>
          <!--              <th style="width: 12%">{{ $t('markupPercentLabel') }} %</th>-->
          <!--              <th style="width: 12%">{{ $t('grossProfitLabel') }}</th>-->
          <!--              <th style="width: 12%">{{ $t('marginLabel') }} %</th>-->
        </tr>
        </thead>
        <tbody class="p-datatable-tbody">
        <tr v-if="managerPositions.services?.count">
          <td>{{ $t('Services') }}</td>
          <td>{{ managerPositions.services?.count }}</td>
          <!--              <td>{{ formatCurrency(managerPositions.services?.purchase_sum) }}</td>-->
          <td>{{ formatCurrency(managerPositions.services?.sell_price) }}</td>
          <!--              <td>{{ formatCurrency(managerPositions.services?.tax_sum) }}</td>-->
          <td>{{ formatCurrency(managerPositions.services?.discount_sum) }}</td>
          <!--              <td>{{ calculateMarkup(managerPositions.services) }}</td>-->
          <!--              <td>{{ formatCurrency(managerPositions.services?.sell_price - managerPositions.services?.purchase_sum) }}</td>-->
          <!--              <td>{{ calculateMargin(managerPositions.services) }}</td>-->
        </tr>
        <tr v-if="managerPositions.requests?.count">
          <td>{{ $t('specialOrderPositionsLabel') }}</td>
          <td>{{ managerPositions.requests?.count }}</td>
          <!--              <td>{{ formatCurrency(managerPositions.requests?.purchase_sum) }}</td>-->
          <td>{{ formatCurrency(managerPositions.requests?.sell_price) }}</td>
          <!--              <td>{{ formatCurrency(managerPositions.requests?.tax_sum) }}</td>-->
          <td>{{ formatCurrency(managerPositions.requests?.discount_sum) }}</td>
          <!--              <td>{{ calculateMarkup(managerPositions.requests) }}</td>-->
          <!--              <td>{{ formatCurrency(managerPositions.requests?.sell_price - managerPositions.requests?.purchase_sum) }}</td>-->
          <!--              <td>{{ calculateMargin(managerPositions.requests) }}</td>-->
        </tr>
        <tr v-if="managerPositions.warehouse_positions?.count">
          <td>{{ $t('Stock items') }}</td>
          <td>{{ managerPositions.warehouse_positions?.count }}</td>
          <!--              <td>{{ formatCurrency(managerPositions.warehouse_positions?.purchase_sum) }}</td>-->
          <td>{{ formatCurrency(managerPositions.warehouse_positions?.sell_price) }}</td>
          <!--              <td>{{ formatCurrency(managerPositions.warehouse_positions?.tax_sum) }}</td>-->
          <td>{{ formatCurrency(managerPositions.warehouse_positions?.discount_sum) }}</td>
          <!--              <td>{{ calculateMarkup(managerPositions.warehouse_positions) }}</td>-->
          <!--              <td>{{ formatCurrency(managerPositions.warehouse_positions?.sell_price - managerPositions.warehouse_positions?.purchase_sum) }}</td>-->
          <!--              <td>{{ calculateMargin(managerPositions.warehouse_positions) }}</td>-->
        </tr>
        <tr v-if="managerPositions.free_positions?.count">
          <td>{{ $t('freePositionsLabel') }}</td>
          <td>{{ managerPositions.free_positions?.count }}</td>
          <!--              <td>{{ formatCurrency(managerPositions.free_positions?.purchase_sum) }}</td>-->
          <td>{{ formatCurrency(managerPositions.free_positions?.sell_price) }}</td>
          <!--              <td>{{ formatCurrency(managerPositions.free_positions?.tax_sum) }}</td>-->
          <td>{{ formatCurrency(managerPositions.free_positions?.discount_sum) }}</td>
          <!--              <td>{{ calculateMarkup(managerPositions.free_positions) }}</td>-->
          <!--              <td>{{ formatCurrency(managerPositions.free_positions?.sell_price - managerPositions.free_positions?.purchase_sum) }}</td>-->
        </tr>
        <tr class="table-opened-info__row--total">
          <td class="no-bottom-border">{{ $t('Total') }}</td>
          <td class="no-bottom-border">{{ calculateCount() }}</td>
          <!--              <td class="no-bottom-border">{{ formatCurrency(calculatePurchaseSum()) }}</td>-->
          <td class="no-bottom-border">{{ formatCurrency(calculateSellSum()) }}</td>
          <!--              <td class="no-bottom-border">{{ formatCurrency(calculateTaxSum()) }}</td>-->
          <td class="no-bottom-border">{{ formatCurrency(calculateTotalDiscountSum()) }}</td>
          <!--              <td class="no-bottom-border"></td>-->
          <!--              <td class="no-bottom-border">{{ formatCurrency(calculateTotalProfit()) }}</td>-->
        </tr>
        </tbody>
      </table>
      <!--      <div class="p-p-2">-->
      <!--        -->
      <!--      </div>-->
      <hr>
      <small class="p-d-flex p-ai-center p-pl-2">
        <i class="ti-info-alt p-mr-1"/>
        {{ $t('salesActivityInfo') }}
      </small>
    </div>
    <div v-else style="text-align: center; padding: 20px;">
      {{ $t('No data available' )}}
    </div>
  </Panel>
</template>

<script>
import formatMixins from "@/mixins/formatMixins";
export default {
  mixins: [ formatMixins ],
  name: 'ManagerOwnSalesPanel',
  props: {
    periodLabel: { type: String, default: '' },
    managerPositions: {
      type: Object,
    }
  },
  data: () => {
    return {
      isCollapsed: false,
    }
  },
  methods: {
    calculateMarkup(position) {
      if (!position) return
      const margin = ((position.sell_price * 100) / position.purchase_sum) - 100

      if (+margin && isFinite(+margin)) {
        return this.formatDecimal(margin) + '%'
      } else {
        return
      }
    },
    calculateCount() {
      const servicesCount = this.managerPositions.services?.count ?? 0
      const requestsCount = this.managerPositions.requests?.count ?? 0
      const warehousePositionsCount = this.managerPositions.warehouse_positions?.count ?? 0
      const freePositionsCount = this.managerPositions.free_positions?.count ?? 0
      return +servicesCount + +requestsCount + +warehousePositionsCount + +freePositionsCount
    },
    calculatePurchaseSum() {
      const servicesPurchaseSum = this.managerPositions.services?.purchase_sum ?? 0
      const requestsPurchaseSum = this.managerPositions.requests?.purchase_sum ?? 0
      const warehousePositionsPurchaseSum = this.managerPositions.warehouse_positions?.purchase_sum ?? 0
      const freePositionsPurchaseSum = this.managerPositions.free_positions?.purchase_sum ?? 0
      return +servicesPurchaseSum + +requestsPurchaseSum + +warehousePositionsPurchaseSum + +freePositionsPurchaseSum
    },
    calculateSellSum() {
      const servicesSellSum = this.managerPositions.services?.sell_price ?? 0
      const requestsSellSum = this.managerPositions.requests?.sell_price ?? 0
      const warehousePositionsSellSum = this.managerPositions.warehouse_positions?.sell_price ?? 0
      const freePositionsSellSum = this.managerPositions.free_positions?.sell_price ?? 0
      return +servicesSellSum + +requestsSellSum + +warehousePositionsSellSum + +freePositionsSellSum
    },
    calculateTaxSum() {
      const servicesTaxSum = this.managerPositions.services?.tax_sum ?? 0
      const requestsTaxSum = this.managerPositions.requests?.tax_sum ?? 0
      const warehousePositionsTaxSum = this.managerPositions.warehouse_positions?.tax_sum ?? 0
      const freePositionsTaxSum = this.managerPositions.free_positions?.tax_sum ?? 0
      return +servicesTaxSum + +requestsTaxSum + +warehousePositionsTaxSum + +freePositionsTaxSum
    },
    calculateTotalDiscountSum() {
      const servicesDiscountSum = this.managerPositions.services?.discount_sum ?? 0
      const requestsDiscountSum = this.managerPositions.requests?.discount_sum ?? 0
      const warehousePositionsDiscountSum = this.managerPositions.warehouse_positions?.discount_sum ?? 0
      const freePositionsDiscountSum = this.managerPositions.free_positions?.discount_sum ?? 0
      return +servicesDiscountSum + +requestsDiscountSum + +warehousePositionsDiscountSum + +freePositionsDiscountSum
    },
    calculateTotalProfit() {
      let profit = 0
      if (this.managerPositions.services) {
        profit += +this.managerPositions.services.sell_price - +this.managerPositions.services.purchase_sum
      }

      if (this.managerPositions.requests) {
        profit += +this.managerPositions.requests.sell_price - +this.managerPositions.requests.purchase_sum
      }

      if (this.managerPositions.warehouse_positions) {
        profit += +this.managerPositions.warehouse_positions.sell_price - +this.managerPositions.warehouse_positions.purchase_sum
      }

      if (this.managerPositions.free_positions) {
        profit += +this.managerPositions.free_positions.sell_price - +this.managerPositions.free_positions.purchase_sum
      }

      return profit
    },
  },
  computed: {
    objectIsEmpty() {
      if (!this.managerPositions) return true
      return !Object.keys(this.managerPositions).length
    }
  }

}
</script>